<form
  autocomplete="off"
  #editInsertCommonSettingModal="ngForm"
  (ngSubmit)="save()"
>
  <h1 mat-dialog-title class="mat-dialog-style m24">{{ "FixedValues" | localize }}</h1>
  <mat-dialog-content style="width: 250px">
    <br />
    <div class="row">
      <div class="col-md-12">
        <mat-form-field *ngIf="user != undefined">
          <mat-select
            name="selectCompany"
            [placeholder]=" 'DefaultCompanyy' | localize "
            [(ngModel)]="defaultCompanyId"
            [disabled]="!user.isChangeCompany"
            (selectionChange)="onSelectCompany()"
          >
            <mat-option [value]="-1">{{ "Choose" | localize }}</mat-option>
            <mat-option [value]="0">{{ "All" | localize }}</mat-option>
            <mat-option *ngFor="let entity of companies" [value]="entity.id">
              {{ entity.code }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      <div class="col-md-12">
        <mat-form-field *ngIf="user != undefined">
          <mat-select
            name="selectWarehouse"
            [placeholder]="'DefaultWarehousee' | localize"
            [(ngModel)]="defaultWarehouseId"
            [disabled]="!user.isChangeWarehouse"
            (selectionChange)="onSelectWarehouse()"
          >
            <mat-option [value]="-1">{{"Choose" | localize}}</mat-option>
            <mat-option [value]="0">{{"All" | localize}}</mat-option>
            <mat-option *ngFor="let entity of warehouses" [value]="entity.id">
              {{ entity.name }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      <div class="col-md-12">
        <mat-form-field>
          <mat-select
            name="selectPrintPoint"
            [placeholder]="'DefaultPrintPoint' | localize"
            [(ngModel)]="defaultPrintPointName"
          >
            <mat-option [value]="''">{{"Choose" | localize}}</mat-option>
            <mat-option
              *ngFor="let entity of printPoints"
              [value]="entity.name"
            >
              {{ entity.name }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    </div>
    <br />
  </mat-dialog-content>
  <div mat-dialog-actions class="bgcgrey mb24" align="end">
    <button mat-button type="button" class="bgcw " (click)="close(false)">
      {{ "Cancel" | localize }}
    </button>
    <button mat-flat-button type="submit" flex="15" color="primary">
      {{ "Save" | localize }}
    </button>
  </div>
</form>
